import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const USERS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"users"> = {
  updateOne: () => ({
    get_users_for_groups: {
      exact: false,
    },
  }),
};
